import { connect } from 'react-redux';

import type { OwnProps } from 'src/components/organisms/Personalisation/components/Input';
import { Input } from 'src/components/organisms/Personalisation/components/Input';
import { selectOutstandingOptions, selectSelectedOption } from 'src/redux/basket/selectors';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';

const mapStateToProps = (state: ReduxApplicationState, props: OwnProps) => ({
  currency: state.product.price.currency,
  error:
    Boolean(props.displayValidation) &&
    selectOutstandingOptions(state).some((opt) => opt.id === props.id),
  value: selectSelectedOption(state, props.id)?.[0]?.name,
});

export const InputContainer = connect(mapStateToProps)(Input);
